import { gql } from '@apollo/client';

const schema = {
  assignment: {
    name: 'setCouponProductShop',
    serviceName: 'unitadmin',
    query: gql`
      mutation setCouponProductShop($coupon_id: String!, $assignment_type: String) {
        setCouponProductShop(coupon_id: $coupon_id, assignment_type: $assignment_type) {
          messages
        }
      }
    `,
  },
};

export default schema;
